import { Button } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';

type RequestBlockedProps = Pick<ChatMessageProps, 'role' | 'createdBy'> & {
  disabled: boolean;
  resubmit: () => void;
};

export const RequestBlocked = ({ role, disabled, createdBy, resubmit }: RequestBlockedProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestSubmitStep' });
  const onClick = useCallback(() => {
    resubmit();
  }, [resubmit]);
  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message.blocked')}
      footer={
        <Button color="primary" variant="contained" disabled={disabled} onClick={onClick}>
          {t('button.resubmit')}
        </Button>
      }
    />
  );
};
